import Navbar from "../components/Navbar/Navbar"
import Slider from "../components/Slider/Slider";
import { homepageBannerImages, newsDetails, publications } from '../common/config/constants'
import InfoBox from "../components/InfoBox/InfoBox";
import Footer from "../components/Footer/Footer";

const Home = () => {
    return (
        <>
            <Navbar />
            <Slider imageDetails={homepageBannerImages} />
            <div className="container-fluid justify-content-center">
                <div className="px-3 py-1 mx-5 mt-1">
                    <InfoBox points={newsDetails} />
                </div>
            </div>
            {/* section for research */}
            <div className="research-details px-3 py-1 mx-5 mt-1">
                <h2 className="text-center" style={{ fontFamily: "cursive", fontSize: "3rem" }}>Our Research</h2>
                <div className="d-flex justify-content-center">
                    <div className="container shadow-lg m-1">
                        <p style={{ fontSize: "1.5rem" }}>Our group is working on cutting-edge highly interdisciplinary area, addressing the problems of electrochemical interest, from fundamental studies of electrochemical energy conversion and storage to electrocatalytic Value Added Product synthesis. Design and development of novel functional materials for electrochemical energy conversion-storage and Electrocatalytic applications are some of our targets.</p><br />
                        <b style={{ fontSize: "1.5rem" }}>Electrocatalysis :</b>&nbsp;
                        <span style={{ fontSize: "1.3rem" }}>
                            Electrocatalytic production of green hydrogen, green ammonia and value added product derived from Electrochemical Oxidation (ECO) and Electrochemical Reduction (ECR), i.e. Electroorganic synthesis in aqueous Electrolytes
                        </span>
                        <br />
                        <b style={{ fontSize: "1.5rem" }}>Electrochemical Energy Storage :</b>&nbsp;
                        <span style={{ fontSize: "1.3rem" }}> 
                            Development of (Zn, Mg, Al etc.) Aqueous batteries (Metal-air and Metal-ion) for sustainable energy storage systems
                        </span>
                        <br />
                    </div>
                </div>
                <img
                    src="images/Research.png"
                    alt="research-image"
                    className="mx-auto d-block"
                    style={{ width: "1200px", height: "auto", maxWidth: "100%" }}
                />
            </div>
            {/* recent publications section */}
            <div className="container-sm">
                <div className="row justify-content-centerd-flex">
                    <div className="col-md-12 d-flex">
                        <Slider imageDetails={{ ...publications, details: publications.details.slice(0, 4) }} card={true} />
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default Home;